import React from 'react';
import { Box } from '@skin-seoul/design-system';
import { COLORS, FONT_SIZES, FONT_WEIGHTS, SPACING } from './constants';
import { CompleteContainer, CompleteTitle, CompleteDesc, CompleteButton } from './SharedStyles';

const COMPLETION_CONTENT = {
  title: 'Thanks for your review! 💜',
  description1: 'Your thoughts will help others find the perfect product.',
  description2: 'We truly appreciate you taking the time!',
  subDescription: 'Your review will be posted on product page and your profile',
  buttonText: 'Continue Shopping',
} as const;

interface CompletionContentProps {
  variant: 'pc' | 'mobile';
}

const CompletionContent = ({ variant }: CompletionContentProps) => (
  <>
    <CompleteTitle
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: SPACING.sm,
        fontSize: FONT_SIZES['2xl'],
        fontWeight: variant === 'mobile' ? FONT_WEIGHTS.medium : FONT_WEIGHTS.semibold,
        color: COLORS.neutral100,
      }}
    >
      {COMPLETION_CONTENT.title}
    </CompleteTitle>
    <CompleteDesc
      style={{
        fontSize: variant === 'mobile' ? FONT_SIZES.sm : FONT_SIZES.base,
        color: COLORS.neutral80,
        fontWeight: FONT_WEIGHTS.normal,
      }}
    >
      {COMPLETION_CONTENT.description1}
    </CompleteDesc>
    <CompleteDesc
      style={{
        fontSize: variant === 'mobile' ? FONT_SIZES.sm : FONT_SIZES.base,
        color: COLORS.neutral80,
        fontWeight: FONT_WEIGHTS.normal,
      }}
    >
      {COMPLETION_CONTENT.description2}
    </CompleteDesc>
    <CompleteDesc
      style={{
        fontSize: FONT_SIZES.xs,
        color: COLORS.neutral50,
        fontWeight: FONT_WEIGHTS.normal,
      }}
    >
      {COMPLETION_CONTENT.subDescription}
    </CompleteDesc>
  </>
);

interface CompleteViewProps {
  onContinue: () => void;
  variant: 'pc' | 'mobile';
}

export const CompleteView = ({ onContinue, variant }: CompleteViewProps) => {
  const handleContinue = () => {
    onContinue();
    window.location.href = '/shop/';
  };

  if (variant === 'mobile') {
    return (
      <>
        <CompleteContainer
          style={{
            alignItems: 'flex-start',
            justifyContent: 'center',
            textAlign: 'left',
            paddingBottom: '80px',
          }}
        >
          <CompletionContent variant="mobile" />
        </CompleteContainer>
        <Box
          position="fixed"
          left="0"
          right="0"
          bottom="0"
          w="full"
          bg={COLORS.background}
          p={`${SPACING.lg} ${SPACING.lg} 68px ${SPACING.lg}`}
          boxSizing="border-box"
        >
          <CompleteButton
            onClick={handleContinue}
            style={{
              width: '100%',
              height: '48px',
              fontSize: FONT_SIZES.sm,
              fontWeight: FONT_WEIGHTS.normal,
              color: `${COLORS.white} !important`,
            }}
          >
            {COMPLETION_CONTENT.buttonText}
          </CompleteButton>
        </Box>
      </>
    );
  }

  return (
    <CompleteContainer>
      <CompletionContent variant="pc" />
      <CompleteButton
        onClick={handleContinue}
        style={{
          width: '100%',
          height: '48px',
          fontSize: FONT_SIZES.sm,
          fontWeight: FONT_WEIGHTS.normal,
        }}
      >
        {COMPLETION_CONTENT.buttonText}
      </CompleteButton>
    </CompleteContainer>
  );
};
